import color from './colorThemes'

export default {
  id: 'boundsBorder',
  source: 'bounds',
  type: 'line',
  layout: {
    'line-cap': 'square',
    'line-join': 'bevel',
  },
  paint: {
    'line-color': color.boundsBorder,
    'line-opacity': 1,
    'line-width': 3,
    'line-dasharray': [2, 1],
  },
}
